import { Injectable } from "@angular/core";
import { IRulesService } from "@comunicare/comunicare-angular-interfaces";
import { IDataSourceBackendParam, IRule, IRuleListInfo } from "@comunicare/comunicare-interfaces";
import { Observable } from "rxjs";
import { SessionService } from "./session.service";
import { RulesApiService } from "./api/rules-api.service";

@Injectable({
  providedIn: "root",
})
export class RulesService implements IRulesService {
  constructor(private api: RulesApiService, private sessionService: SessionService) {}

  public getRule(identifier: string): Observable<IRule> {
    return this.api.getRule(identifier);
  }

  public createRule(rule: IRule): Observable<IRule> {
    return this.api.createRule(rule);
  }

  public updateRule(rule: IRule): Observable<IRule> {
    return this.api.updateRule(rule);
  }

  public deleteRule(identifier: string): Observable<boolean> {
    return this.api.deleteRule(identifier);
  }

  public getRulesInfos(params: IDataSourceBackendParam): Observable<IRuleListInfo[]> {
    const orgsAndServicesRefs = params.services?.length ? params.services.join(",") : undefined;
    return this.api.getRulesInfos(
      orgsAndServicesRefs,
      params.pageNumber,
      params.pageSize,
      params.search,
      params.sortId,
      params.sortOrder,
      JSON.stringify(params.filters),
      // the careplan names of the scopes are stored as translation keys, resolved by the server
      this.sessionService.userLang
    );
  }

  public getRulesInfosCount(params: IDataSourceBackendParam): Observable<{ count: number }> {
    const orgsAndServicesRefs = params.services?.length ? params.services.join(",") : undefined;
    return this.api.getRulesInfosCount(orgsAndServicesRefs, params.search, JSON.stringify(params.filters));
  }
}
